import { ExpoLogo } from "@/components/expo-logo";

interface PublicLayoutProps {
  children: React.ReactNode;
}

export function PublicLayout({ children }: PublicLayoutProps) {
  return (
    <div className="min-h-dvh">
      <div className="flex justify-center pt-6 pb-4">
        <ExpoLogo to="/" />
      </div>
      {children}
    </div>
  );
}
